module.exports = __webpack_public_path__ + "assets/img/media_1.69a79b0a.png";